import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asiaDate'
})
export class AsiaDatePipe implements PipeTransform {

  transform(value: string | Date | null): string {
    if (!value) {
      return '';
    }

    let date: Date;

    if (typeof value === 'string' && !value.endsWith('Z') && !value.match(/[+-]\d{2}:\d{2}$/)) {
      // No timezone suffix = server is returning UTC without 'Z' — add it
      date = new Date(value + 'Z');
    } else {
      date = new Date(value);
    }

    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'Asia/Manila',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };

    const parts = new Intl.DateTimeFormat('en-PH', options).formatToParts(date);
    const get = (type: string) => parts.find(p => p.type === type)?.value || '';

    return `${get('month')}-${get('day')}-${get('year')} ${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
  }
}
